import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { exhaustMap, filter, takeUntil, tap } from 'rxjs/operators';
import { AuthService, GenericError } from '@auth0/auth0-angular';
import { DOCUMENT } from '@angular/common';
import { ClientService } from './services/client.service';
import { fromEvent, Subject } from 'rxjs';
import { IsNewVersionMsgAppComponent } from './shared/components/is-new-version-msg-app/is-new-version-msg-app.component';
import { UpdateAppService } from './services/update-app.service';
import { Router } from '@angular/router';
import { NgcCookieConsentService } from 'ngx-cookieconsent';
import { LocalStorageService } from './services/local-storage.service';

@Component({
  selector: 'tm-root',
  template: `
  <div class="relative">
    <tm-signal-r-error-connection></tm-signal-r-error-connection>
  </div>
  <router-outlet></router-outlet>
  `,
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();
  constructor(
    private authService: AuthService,
    private snackbar: MatSnackBar,
    private readonly router: Router,
    @Inject(DOCUMENT) private _document: Document,
    private readonly clientService: ClientService,
    private readonly updateAppService: UpdateAppService,
    private readonly ccService: NgcCookieConsentService,
    private readonly localStorageService: LocalStorageService
  ) { }

  ngOnInit(): void {
    const tlCookie = this.localStorageService.getItem('tl-cookie');
    if (!!tlCookie === true) {
      this.ccService.destroy();
    }

    this.ccService.statusChange$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(() => {
      this.localStorageService.setItem('tl-cookie', 'true');
    });

    this.updateAppService.isLoadNewVersion$.pipe(
      takeUntil(this.destroy$),
      filter(isNewVersion => isNewVersion),
    ).subscribe(() => this.snackbar.openFromComponent(IsNewVersionMsgAppComponent));

    fromEvent(this._document, 'visibilitychange').pipe(
      takeUntil(this.destroy$),
      filter(() => this._document.visibilityState === 'visible')
    ).subscribe(() => this.clientService.refreshState$.next());

    this.authService.error$.pipe(
      takeUntil(this.destroy$),
      tap(err => console.error('auth0Service error:', err)),
      filter((e) => e instanceof GenericError && e.error === 'login_required'),
      exhaustMap(() => this.authService.loginWithRedirect())
    ).subscribe();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}